import { css } from '@emotion/react'
import {
  cssVar,
  gemVar,
  Spacing,
  ThemedColors,
  Typography,
  ZIndex,
} from '@opallabs/gem'
import {
  gemCopilotOpenSelector,
  gemPanelInlineSize,
  gemPanelTransition,
} from '@opallabs/gem-copilot/src/shared'
import { modernWithFallback } from '@opallabs/lambda'
import { content as parentContentStyle } from '../../styles'

export const modal = css({
  color: gemVar(ThemedColors.TextPrimary),
  flex: '1 1 auto',
  flexDirection: 'row',
  zIndex: ZIndex.Shroud.Content + ZIndex.Drawer.Content,
  transition: 'inset-inline-end 500ms ease, inline-size 500ms ease',

  [`.${gemCopilotOpenSelector} &`]: {
    insetInlineEnd: gemPanelInlineSize,
    inlineSize: `calc(100% - ${gemPanelInlineSize})`,
    transition: `inset-inline-end ${gemPanelTransition} ease, inline-size ${gemPanelTransition} ease`,
  },
})

export const preview = css({
  inlineSize: '100%',
  marginBlock: '0',
  marginInline: 'auto',
  paddingBlock: '80px',
  paddingInline: '0',
  ...modernWithFallback(
    [{ overflowBlock: 'auto' }, { overflowY: 'auto' }],
    'overflow-block: auto'
  ),
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'center',
  color: cssVar(ThemedColors.TextPrimary),

  '> *': {
    inlineSize: '100%',
    maxInlineSize: '680px',
  },
})

export const previewHeader = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBlockEnd: Spacing.L,
})

export const previewHeaderTitle = css({
  ...Typography.H400,
  marginBlock: 0,
})

export const previewHeaderDate = css({
  ...Typography.T500,
  color: ThemedColors.TextSecondary,
})

export const history = css({
  inlineSize: '100%',
  maxInlineSize: '400px',
  flexGrow: 0,
  borderWidth: 1,
  borderStyle: 'solid',
  borderStartEndRadius: Spacing.M,
  display: 'flex',
  flexFlow: 'column nowrap',
  borderColor: `var(${ThemedColors.StrokeSecondary1})`,

  ...Typography.T500,
})

export const historyList = css({
  borderBlockEnd: `1px solid var(${ThemedColors.StrokeSecondary1})`,
  ...modernWithFallback(
    [{ overflowBlock: 'auto' }, { overflowY: 'auto' }],
    'overflow-block: auto'
  ),
  marginBlockStart: Spacing.S,
  marginBlockEnd: Spacing.M,
  paddingInline: Spacing.S,
  inlineSize: 'auto',
})

export const historyItem = (isDisabled: boolean) =>
  css({
    position: 'relative',

    '.lapidary-history-title, .lapidary-history-subtitle': {
      opacity: isDisabled ? 0.5 : 1,
    },

    '&:not(:last-child)::before': {
      content: '""',
      backgroundColor: `var(${ThemedColors.StrokeSecondary1})`,
      blockSize: Spacing.M,
      insetInlineStart: Spacing.L,
      position: 'absolute',
      insetBlockStart: '102%',
      inlineSize: '1px',
    },
  })

export const content = css({
  ...parentContentStyle({ isFullScreen: false, controlBarPlacement: 'bottom' }),
  padding: 0,

  '.text-center-justify': {
    maxInlineSize: 'inherit',
  },
})

export const diffContent = css({
  '.diff.delete': {
    color: `var(${ThemedColors.TextError})`,
    textDecoration: 'line-through',
  },
  '.diff.insert': {
    color: `var(${ThemedColors.TextSuccess})`,
  },
  '& :nth-child(1 of .diff) > :first-child': {
    marginBlockStart: 0,
  },
  'li > .diff > p': {
    marginBlock: 8,
  },
})

export const footerButtonContainer = css({
  display: 'flex',
  gap: Spacing.S,
  margin: `0px auto ${Spacing.M}px ${Spacing.S * 1.25}px`,
})
